'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getAvg = require('shared/utils/getAvg');

var _getAvg2 = _interopRequireDefault(_getAvg);

var _getValues = require('./getValues');

var _getValues2 = _interopRequireDefault(_getValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import arrayAsObj from 'shared/utils/arrayAsObj';
//import objAsArray from 'shared/utils/objAsArray';
var MAX_SCALE = 10;
//const getMax = values => values.length * MAX_SCALE;
var getMax = function getMax() {
  return MAX_SCALE;
};

var getInterest = function getInterest(jobInterests, userInterests, interests, constants) {
  //const interests = objAsArray(interestsObj);
  //const jobInterests = arrayAsObj(jobInterestsArr || {});

  var values = (0, _getValues2.default)(jobInterests, userInterests, interests, constants);

  var avg = (0, _getAvg2.default)(values);

  var interest = (getMax(constants) - avg) / getMax(constants);

  return interest < 0 ? 0 : interest;
};

exports.default = getInterest;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/utils/match/interest/getInterest.js
// module id = 1314
// module chunks = 0